import { useDispatch, useSelector } from "app/hooks";
import { investmentDetailsActions } from "../../app/features/investmentDetails/investmentDetailsSlice";

export const useInvestmentDetails = () => {
  const dispatch = useDispatch();
  const {
    product,
    clientName,
    hasDrawdown,
    drawdownPercent: drawdown,
  } = useSelector((state) => state.investmentDetails);

  const handleProductChange = (product: string) => {
    dispatch(investmentDetailsActions.updateProduct(product));
  };

  const handleClientNameChange = (clientName: string) => {
    dispatch(investmentDetailsActions.updateClientName(clientName));
  };

  const handleHasDrawdownChange = (value: boolean) => {
    dispatch(investmentDetailsActions.updateHasDrawdown(value));
    if (!value) {
      dispatch(investmentDetailsActions.updateDrawdownPercent(0));
    }
  };

  const handleDrawdownChange = (amount: number) => {
    if (!isNaN(amount)) {
      dispatch(investmentDetailsActions.updateDrawdownPercent(amount));
    }
  };

  const handleDrawdownBlur = (amount: number) => {
    if (isNaN(amount)) {
      dispatch(investmentDetailsActions.updateDrawdownPercent(0));
    }
  };

  return {
    clientName,
    handleClientNameChange,
    product,
    handleProductChange,
    hasDrawdown,
    handleHasDrawdownChange,
    drawdown,
    handleDrawdownChange,
    handleDrawdownBlur,
  };
};
